import { useMutation, useQueryClient } from '@tanstack/react-query';
import { findFirstAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
import { CREATE_PROJECT_ACTIONS } from './actionNames';
import { invalidateProjectLists } from './queries';
/** Shared mutationKey so consumers can detect in-flight creates via `useIsMutating`. */
export const CREATE_DL_PROJECT_KEY = ['createDLProject'];
export function useCreateDLProject() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: [...CREATE_DL_PROJECT_KEY],
        mutationFn: async ({ name, address, description }) => {
            if (!user)
                throw new Error('not authenticated');
            const resolved = findFirstAction(user, CREATE_PROJECT_ACTIONS);
            if (!resolved)
                throw new Error('createDLProject action unavailable');
            const body = { name };
            if (address && address.length > 0)
                body.address = address;
            if (description && description.length > 0)
                body.description = description;
            const response = await invokeAction(resolved.action, user.token, { body });
            if (!response.ok)
                throw new Error(`${resolved.name} returned ${response.status}`);
            const json = (await response.json());
            return json.object ?? null;
        },
        onSuccess: () => {
            invalidateProjectLists(queryClient, user?.email);
        },
    });
}
